import dayjs from 'dayjs'

/**
 * Глибоке клонування об'єкта з підтримкою циклічних посилань
 * @param obj - об'єкт для клонування
 * @param clones - WeakMap для відстеження вже клонованих об'єктів (запобігає циклічним посиланням)
 * @returns клонований об'єкт
 */
export const DeepCloneTask = <T>(obj: T, clones: WeakMap<any, any> = new WeakMap()): T => {
    // Примітивні типи та null повертаються як є
    if (obj === null || typeof obj !== 'object') {
        return obj
    }

    // dayjs об'єкти не клонуємо
    if (dayjs.isDayjs(obj)) {
        return obj
    }

    // Перевіряємо, чи об'єкт вже був клонований (циклічне посилання)
    if (clones.has(obj)) {
        return clones.get(obj)
    }

    // Клонування масивів
    if (Array.isArray(obj)) {
        const newArray: any[] = []
        clones.set(obj, newArray)

        for (let i = 0; i < obj.length; i++) {
            newArray[i] = DeepCloneTask(obj[i], clones)
        }

        return newArray as T
    }

    // Функції повертаються як є
    if (obj instanceof Function) {
        return obj
    }

    // Клонування об'єктів
    const newObj: any = {}
    clones.set(obj, newObj)

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            newObj[key] = DeepCloneTask((obj as any)[key], clones)
        }
    }

    return newObj as T
}
